import React from 'react';

export default function ModalFooter({ className }) {
  return (
    <footer
      className={`flex flex-col items-center text-opaque-navy bg-white border-t-0 p-t-0 ${className}`}
      role={ModalFooter.role}
    >
      <div className="flex flex-col items-center text-center">
        <div>
          <p>
            Credit Key loans are issued by First Electronic Bank, Member FDIC
          </p>
        </div>
        <div className="flex justify-between divide-x my-1">
          <a
            href="https://www.creditkey.com/legal/privacy-policy"
            target="_blank"
            rel="noreferrer"
            className="px-4 no-underline hover:text-primary-blue"
          >
            Privacy Policy
          </a>
          <a
            href="https://www.creditkey.com/legal/terms-of-service-and-electronic-disclosures"
            target="_blank"
            rel="noreferrer"
            className="px-4 no-underline hover:text-primary-blue"
          >
            Terms of Service
          </a>
          <a
            href="https://www.firstelectronic.com/privacy-policy/"
            target="_blank"
            rel="noreferrer"
            className="px-4 no-underline hover:text-primary-blue"
          >
            FEB Privacy Policy
          </a>
        </div>
      </div>
    </footer>
  );
}

ModalFooter.role = 'modal-footer-component';
